import React, {useContext, useEffect, useState} from 'react'
import {
  Input,
  AreaDeTexto,
  InputMoneda,
  InputConResultado,
  ListaDesplegable,
  ListaDesplegableConSelector,
  ListaDesplegableConResultado,
} from '../inputs'
import {BotonSimple} from '../Botones'
import {ContextoRecargarSaldo, ContextoAplicacion} from '../../contexto'
import {
  ObtenerEmpresaPorId,
  ObtenerConfiguracionPorParticion,
} from '../../microservicios'
import {useForm, Controller} from 'react-hook-form'
import {ContenedorTituloResaltado} from '../Contenedores'
import {aplicarFormatoMoneda} from '../../utils'
import {AlertaDinamica} from '../MostrarEnPantalla'
import clsx from 'clsx'
import {
  OPCIONES_RETENCIONES_RENTA,
  OPCIONES_SOBRETASA_BOMBERIL,
} from '../../constantes'
import {ObtenerTodasLasCiudades} from '../../cache/servicios-cache'
import {removerAcentos} from '../../utils'

const FormularioRecargarCuentaServicios = ({manejarGuardar}) => {
  const contextoAplicacion = useContext(ContextoAplicacion)
  const contextoRecargarSaldo = useContext(ContextoRecargarSaldo)

  const valoresTablaPorDefecto = {
    montoRecarga: '',
    retencionRenta: '',
    rentaTotal: '',
    retencionICA: '',
    ICATotal: '',
    sobretasaBomberil: '',
    bomberilTotal: '',
    tarifaIVA: '',
    totalIVA: '',
    valorRecibido: '',
  }
  const [valoresTabla, setValoresTabla] = useState(valoresTablaPorDefecto)
  const [alertaICA, setAlertaICA] = useState(false)
  const [totalTabla, setTotalTabla] = useState(0)
  const [municipio, setMunicipio] = useState({})
  const [aplicaRetenciones, setAplicaRetenciones] = useState('0') //VALOR POR DEFECTO "" (string vacío), se cambio a "0" PARA NO USAR RETENCIONES

  const [municipiosSedesCendiatra, setMunicipiosSedesCendiatra] = useState([
    {
      Id: 1,
      Nombre: 'No aplica',
      Tarifa: 0,
    },
  ])

  const idEmpresa = contextoAplicacion.infoEmpresa.id ?? 0

  const {
    trigger,
    control,
    setValue,
    clearErrors,
    setError,
    formState: {errors},
  } = useForm({
    mode: 'onChange',
  })

  useEffect(() => {
    const cargarinformacionInicial = async () => {
      try {
        const datosCuentasMunicipios = await ObtenerConfiguracionPorParticion(
          'TarifasRetenciones'
        )
        const todasLasCiudades = await ObtenerTodasLasCiudades()
        const municipiosParaMostrar = datosCuentasMunicipios.data.map(
          (municipio) => {
            return {
              Id: municipio.cuenta,
              Nombre: municipio.municipio,
              Tarifa: municipio.tarifa,
              MunicipioId: todasLasCiudades.find((ciudad) => {
                let nombreMunicipio = municipio.municipio.trim()
                if (nombreMunicipio.startsWith('IBAGUE')) {
                  nombreMunicipio = nombreMunicipio.split(' ')[0]
                }
                return (
                  removerAcentos(ciudad.Nombre) ===
                  removerAcentos(nombreMunicipio)
                )
              })?.Id,
            }
          }
        )
        setMunicipiosSedesCendiatra((prev) => [
          ...prev,
          ...municipiosParaMostrar,
        ])
      } catch (error) {
        console.log(error)
      }
    }
    if (idEmpresa) {
      cargarinformacionInicial()
      obtenerDatosEmpresa()
    }
  }, [idEmpresa])

  useEffect(() => {
    const valor = Number(aplicaRetenciones)
    if (!valor) {
      setValoresTabla((prev) => ({
        ...valoresTablaPorDefecto,
        montoRecarga: prev.montoRecarga,
      }))
      setMunicipio({})
      setValue('municipio', '')
    }
    trigger()
  }, [aplicaRetenciones])

  const obtenerDatosEmpresa = async () => {
    ObtenerEmpresaPorId(idEmpresa).then((res) => {
      contextoRecargarSaldo.setFormularioRecargarSaldo({
        ...contextoRecargarSaldo.formularioRecargarSaldo,
        identificacionCliente: res?.data?.nit,
      })
      contextoRecargarSaldo.setDataPdf({
        documento: res?.data?.nit,
        nombre: res?.data?.nombre,
        direccion: res?.data?.direccion,
        telefono: res?.data?.telefono,
      })
    })
  }

  const calcularRetencionRenta = (valor) => {
    if (valor && valoresTabla?.montoRecarga) {
      const total = (valoresTabla?.montoRecarga * valor) / 100
      setValoresTabla((prev) => {
        return {
          ...prev,
          rentaTotal: isNaN(total) ? '' : total,
        }
      })
    } else if (!valor) {
      setValoresTabla((prev) => {
        return {
          ...prev,
          rentaTotal: '',
        }
      })
    }
  }

  const calcularRetencionICA = (valor) => {
    if (valor && valoresTabla?.montoRecarga) {
      const total = (valoresTabla?.montoRecarga * valor) / 1000
      setValoresTabla((prev) => {
        return {
          ...prev,
          ICATotal: isNaN(total) ? '' : total,
        }
      })
      setAlertaICA(false)
    } else if (!valor) {
      setValoresTabla((prev) => {
        return {
          ...prev,
          ICATotal: '',
          bomberilTotal: '',
        }
      })
    }
  }

  const calcularSobretasaBomberil = (valor) => {
    if (!valoresTabla?.ICATotal && valor) {
      return setAlertaICA(true)
    }
    if (valor && valoresTabla?.montoRecarga) {
      const total = (valoresTabla?.ICATotal * valor) / 100
      setValoresTabla((prev) => {
        return {
          ...prev,
          bomberilTotal: isNaN(total) || !valoresTabla?.ICATotal ? '' : total,
        }
      })
      setAlertaICA(false)
    } else if (!valor) {
      setValoresTabla((prev) => {
        return {
          ...prev,
          bomberilTotal: '',
        }
      })
      setAlertaICA(false)
    }
  }

  const calcularValoresEnTabla = (nombrePropiedad, valor) => {
    const funcionesPorPropiedad = {
      retencionRenta: () => calcularRetencionRenta(valor),
      retencionICA: () => calcularRetencionICA(valor),
      sobretasaBomberil: () => calcularSobretasaBomberil(valor),
    }
    if (nombrePropiedad in funcionesPorPropiedad) {
      funcionesPorPropiedad[nombrePropiedad]()
    }
  }
  const modificarValoresTabla = (nombrePropiedad, valor) => {
    setValoresTabla((prev) => {
      return {
        ...prev,
        [nombrePropiedad]: valor ?? '',
      }
    })
    calcularValoresEnTabla(nombrePropiedad, valor)
    if (nombrePropiedad === 'montoRecarga' && !valor) {
      setValoresTabla((prev) => {
        return {
          ...prev,
          rentaTotal: '',
          ICATotal: '',
          bomberilTotal: '',
        }
      })
    }
  }
  useEffect(() => {
    const calcularValorTotal = () => {
      const valoresNumericos = [
        valoresTabla?.montoRecarga,
        valoresTabla?.rentaTotal,
        valoresTabla?.ICATotal,
        valoresTabla?.bomberilTotal,
      ]
        .filter((valor) => valor !== '')
        .map((valor) => parseFloat(valor))
      if (valoresNumericos.length >= 1) {
        const resultado = valoresNumericos
          .slice(1)
          .reduce(
            (acumulador, valor) => acumulador - valor,
            valoresNumericos[0]
          )

        setValoresTabla((prev) => {
          return {
            ...prev,
            valorRecibido: resultado ?? '',
          }
        })

        return setTotalTabla(resultado)
      } else {
        return setTotalTabla(0)
      }
    }
    calcularValorTotal()
  }, [
    valoresTabla?.montoRecarga,
    valoresTabla?.rentaTotal,
    valoresTabla?.ICATotal,
    valoresTabla?.bomberilTotal,
  ])

  useEffect(() => {
    calcularRetencionRenta(valoresTabla?.retencionRenta)
    calcularRetencionICA(valoresTabla?.retencionICA)
    calcularSobretasaBomberil(valoresTabla?.sobretasaBomberil)
  }, [valoresTabla?.montoRecarga, valoresTabla?.ICATotal])

  const manejarMunicipioSeleccionado = (municipio) => {
    if (municipio) {
      modificarValoresTabla('retencionICA', municipio.Tarifa)
      setValue('municipio', municipio.Nombre)
      clearErrors('municipio')
      setMunicipio(municipio)
    } else {
      modificarValoresTabla('sobretasaBomberil', '')
      modificarValoresTabla('retencionICA', '')
      setError('municipio', {type: 'require', message: ''})
      setValue('municipio', '')
      setMunicipio('')
    }
    if (!municipio?.Tarifa) {
      modificarValoresTabla('sobretasaBomberil', '')
      modificarValoresTabla('retencionICA', '')
    }
  }

  const manejarCambioDetalle = (detalle) => {
    contextoRecargarSaldo.setFormularioRecargarSaldo({
      ...contextoRecargarSaldo.formularioRecargarSaldo,
      detalle: detalle,
    })
  }

  return (
    <>
      <div className="w-full flex justify-center items-center flex-wrap mt-20">
        <div className="w-1/2 flex justify-center items-center ">
          <Input
            estilosContenedor={'w-10/12'}
            onChange={null}
            estilosInput={
              'appearance-none rounded relative block  w-full  p-1.5 border border-cendiatra bg-cendiatra-gris-placeholder text-white  rounded-lg focus:outline-none focus:ring-indigo-500 focus:border-cendiatra focus:z-10 sm:text-sm '
            }
            tipo={'date'}
            titulo={'Fecha'}
            valor={contextoRecargarSaldo.formularioRecargarSaldo.fecha}
            deshabilitado={true}
          />
        </div>
        <div className="w-1/2 flex justify-center items-center ">
          <Input
            estilosContenedor={'w-10/12'}
            onChange={null}
            estilosInput={
              'appearance-none rounded relative block w-full  p-1.5 border border-cendiatra bg-cendiatra-gris-placeholder text-white  rounded-lg focus:outline-none focus:ring-indigo-500 focus:border-cendiatra focus:z-10 sm:text-sm '
            }
            tipo={'text'}
            titulo={'Identificación del cliente'}
            valor={
              contextoRecargarSaldo.formularioRecargarSaldo
                .identificacionCliente
            }
            deshabilitado={true}
          />
        </div>
      </div>
      <div className="w-full flex justify-center items-center flex-wrap mt-20 border border-cendiatra rounded-lg py-10">
        <div className="w-11/12 flex justify-center items-center flex-wrap ">
          <div className="w-11/12 flex justify-end items-center my-2 p-5">
            <div className="w-5/12 flex justify-end items-center">
              <span className="w-8/12 text-cendiatra-verde-3 font-bold text-2xl text-right pr-5">
                Monto a recargar *
              </span>
              <InputMoneda
                estilosContenedor={'w-7/12 flex  items-center'}
                estilosInput={clsx(
                  'appearance-none rounded relative block w-full p-1.5 border text-cendiatra-verde-2 font-bold text-center rounded-lg focus:outline-none focus:ring-indigo-500 focus:z-10 sm:text-sm',
                  {
                    'border-cendiatra': valoresTabla.montoRecarga,
                    'border-cendiatra-rojo-1': !valoresTabla.montoRecarga,
                  }
                )}
                valor={valoresTabla.montoRecarga}
                formatoVacio={true}
                onValueChange={(e) =>
                  modificarValoresTabla('montoRecarga', e.floatValue)
                }
                titulo={''}
              />
            </div>
          </div>
          {/* <div className="w-10/12 flex justify-center items-center mt-10">
            <div className="w-full flex justify-center items-center border-2 border-cendiatra-gris-2 rounded-2xl p-5 my-2">
              <span className="w-6/12 text-cendiatra-gris-1 mr-3 text-lg">
                ¿Aplica retenciones?
              </span>
              <div className="w-6/12 flex flex-wrap justify-end items-center">
                <ListaDesplegable
                  onChange={(e) => setAplicaRetenciones(e.target.value)}
                  estilosContenedor={'w-7/12'}
                  estilosLista={clsx(
                    'appearance-none rounded relative block w-full p-1.5 border text-cendiatra-gris-3 rounded-lg focus:outline-none focus:ring-indigo-500 focus:z-10 sm:text-sm',
                    {
                      'border-cendiatra-rojo-1': !aplicaRetenciones,
                      'border-cendiatra focus:border-cendiatra':
                        aplicaRetenciones,
                    }
                  )}
                  titulo={''}
                  opciones={[
                    {Id: 0, Nombre: 'No'},
                    {Id: 1, Nombre: 'Sí'},
                  ]}
                  valor={aplicaRetenciones}
                />
              </div>
            </div>
          </div> */}
          {/* CODIGO COMENTADO POR CAMBIO EN RETENCIONES */}
        </div>
        {+aplicaRetenciones ? (
          <>
            <div className="w-11/12 flex justify-center items-center my-2 flex-wrap">
              <div className="w-10/12 flex justify-end items-center my-2">
                <AlertaDinamica
                  mostrarAlerta={true}
                  mensaje={
                    'Recuerde si aplica retenciones, estas deben de estar debidamente certificadas y enviadas al correo electrónico impuestos@cendiatra.com'
                  }
                  estilosTexto={'w-full font-bold text-lg'}
                  color={'text-cendiatra-rojo-2'}
                />
              </div>
            </div>
            <div className="w-11/12 flex justify-center items-center my-2 flex-wrap">
              <div className="w-11/12 flex justify-center items-center flex-wrap p-2 text-cendiatra font-bold">
                <ContenedorTituloResaltado
                  titulo={'TARIFAS DE RETENCIÓN'}
                  margenContenedor={'mb-20 border-none'}
                  paddingContenedor={
                    'w-full flex justify-center items-center flex-wrap '
                  }
                >
                  <span className="w-8/12 mt-3 text-center text-cendiatra-rojo-1 text-xl">
                    Es responsabilidad del cliente conocer e ingresar sus
                    tarifas de retención.
                  </span>
                  <span className="w-8/12  text-center text-cendiatra-rojo-1 text-xl">
                    Recuerde que las retenciones se deben realizar con cada
                    pago. (Art. 392 ET).
                  </span>
                  <span className="w-8/12  text-center text-cendiatra-rojo-1 text-xl">
                    Por favor, asesórese para diligenciar correctamente esta
                    información.
                  </span>
                  <span className="w-8/12 mt-3 text-center text-cendiatra-gris-1 text-xl ">
                    No olvide que la base para practicar la retención en la
                    fuente, inicia a partir de
                  </span>
                  <span className="w-8/12  text-center text-cendiatra-gris-1 text-xl mb-3">
                    4 UVT ($ 199.000 COP año 2025)
                  </span>
                  <div className="w-95% flex justify-end items-center">
                    <ListaDesplegableConResultado
                      titulo={
                        'Tarifa de retención de Renta (% sobre valor de recarga)'
                      }
                      estilosTitulo={'text-lg'}
                      estilosInput={clsx(
                        'appearance-none rounded relative block w-full p-1.5 border border-cendiatra rounded-lg focus:outline-none focus:ring-indigo-500 focus:border-cendiatra focus:z-10 sm:text-sm',
                        {
                          'text-cendiatra-verde-3 font-bold text-center text-2xl':
                            aplicaRetenciones,
                          'bg-cendiatra-gris-placeholder pointer-events-none text-white placeholder-white':
                            !aplicaRetenciones,
                        }
                      )}
                      opciones={OPCIONES_RETENCIONES_RENTA}
                      valor={valoresTabla.retencionRenta}
                      funcion={(e) =>
                        modificarValoresTabla('retencionRenta', e.target.value)
                      }
                      totalCalculado={valoresTabla.rentaTotal}
                      colorTexto={'text-cendiatra-verde-3'}
                      opcionPorDefecto={'0.00%'}
                    />
                  </div>
                  <div className="w-full flex justify-center items-center flex-wrap border-2  rounded-lg py-5 my-2">
                    <div className="w-95% flex justify-end items-center border-2  rounded-3xl p-5">
                      <span className="w-7/12  text-cendiatra-gris-2 mr-3 text-lg ">
                        *Comience a escribir el municipio desde donde está
                        haciendo la recarga y al obtener resultados selecciónelo
                        de la lista desplegable.
                      </span>
                      <div className="w-5/12 flex flex-wrap justify-end items-center">
                        <span className="w-5/12 text-cendiatra-verde-3 font-bold text-lg text-right pr-5">
                          Municipio*
                        </span>
                        <Controller
                          name="municipio"
                          control={control}
                          rules={{
                            required: true,
                          }}
                          render={({field: {}, fieldState: {error}}) => (
                            <ListaDesplegableConSelector
                              titulo={''}
                              estilosPersonalizados={'w-7/12'}
                              estilosInput={clsx(
                                'appearance-none rounded relative block w-full text-center p-1.5 border text-center rounded-lg focus:outline-none focus:ring-indigo-500 focus:z-10 sm:text-sm',
                                {
                                  'border-cendiatra-rojo-1': error,
                                  'border-cendiatra': !error,
                                }
                              )}
                              textoPorDefecto={'ELEGIR'}
                              placeholder={'Ciudad'}
                              datosParaMostrar={municipiosSedesCendiatra}
                              manejarOpcionSeleccionada={
                                manejarMunicipioSeleccionado
                              }
                              textoToolTip={''}
                            />
                          )}
                        />
                      </div>
                    </div>
                    <div className="w-95% flex justify-end items-center">
                      <InputConResultado
                        titulo={
                          'Tarifa de retención ICA (valor de recarga * tarifa / 1000)'
                        }
                        estilosInput={`appearance-none rounded relative block w-full text-center p-1.5 border border-cendiatra  rounded-lg focus:outline-none focus:ring-indigo-500 focus:border-cendiatra focus:z-10 sm:text-sm bg-cendiatra-gris-placeholder pointer-events-none text-white placeholder-white`}
                        placeholder={'0,00'}
                        valor={valoresTabla.retencionICA}
                        funcion={(e) =>
                          modificarValoresTabla('retencionICA', e.floatValue)
                        }
                        totalCalculado={valoresTabla.ICATotal}
                        descripcion={
                          'Res. DDI-023769 Grandes contribuyentes Bogotá.'
                        }
                        porcentaje={false}
                        prefix={''}
                        isAllowed={(values) => {
                          return (values?.floatValue ?? 0) <= 10
                        }}
                      />
                    </div>
                    <div className="w-95% flex justify-end items-center flex-wrap">
                      <ListaDesplegableConResultado
                        estilosTitulo={'text-lg'}
                        titulo={'Sobretasa Bomberil (% sobre el valor del ICA)'}
                        estilosInput={clsx(
                          'appearance-none rounded relative block w-full text-center p-1.5 border border-cendiatra rounded-lg focus:outline-none focus:ring-indigo-500 focus:border-cendiatra focus:z-10 sm:text-sm',
                          {
                            'text-cendiatra-verde-3 font-bold text-center':
                              !Object.keys(errors).includes('municipio') &&
                              municipio.Tarifa,
                            'bg-cendiatra-gris-placeholder pointer-events-none text-white placeholder-white':
                              Object.keys(errors).includes('municipio') ||
                              !municipio.Tarifa,
                          }
                        )}
                        opciones={OPCIONES_SOBRETASA_BOMBERIL}
                        valor={valoresTabla.sobretasaBomberil}
                        funcion={(e) =>
                          modificarValoresTabla(
                            'sobretasaBomberil',
                            e.target.value
                          )
                        }
                        totalCalculado={valoresTabla.bomberilTotal}
                        colorTexto={'text-cendiatra-verde-3'}
                        opcionPorDefecto={'0.00%'}
                      />
                      <span className="w-full text-cendiatra-gris-1 font-bold ml-2 -mt-2 text-lg">
                        Recuerde si aplica la sobre tasa Bomberil debe
                        seleccionar el porcentaje
                      </span>
                    </div>
                    <div className="w-full flex justify-start items-center">
                      <div className="w-6/12"></div>
                      <div className="w-5/12">
                        <AlertaDinamica
                          mostrarAlerta={alertaICA}
                          mensaje={
                            'Se requiere la tarifa ICA para calcular Bomberil'
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="w-95% flex justify-end items-center">
                    <InputConResultado
                      titulo={
                        'Tarifa retención de IVA (% sobre el valor del IVA)'
                      }
                      estilosTitulo={'text-cendiatra-gris-4'}
                      estilosInput={`appearance-none rounded relative block w-full text-center p-1.5 border border-cendiatra text-cendiatra-gris-3  rounded-lg focus:outline-none focus:ring-indigo-500 focus:border-cendiatra focus:z-10 sm:text-sm 
                ${
                  false //Descativado hasta que desidan darle funcionalidad
                    ? 'text-cendiatra-gris-3'
                    : 'bg-cendiatra-gris-placeholder pointer-events-none text-white placeholder-white'
                }
                
                `}
                      valor={valoresTabla.tarifaIVA}
                      funcion={(e) =>
                        modificarValoresTabla('tarifaIVA', e.floatValue)
                      }
                      totalCalculado={valoresTabla.totalIVA}
                      porcentaje={false}
                      deshabilitarTab={true}
                    />
                  </div>
                  <div className="w-full flex justify-end items-center my-2">
                    <div className="w-3/12 flex justify-center ">
                      <span className=" text-cendiatra-verde-2 font-bold text-start text-2xl">
                        Valor a recibir
                      </span>
                    </div>
                    <div className="w-3/12 flex justify-center">
                      <span className="text-cendiatra-verde-2 font-bold text-center text-2xl">
                        {aplicarFormatoMoneda(totalTabla)}
                      </span>
                    </div>
                  </div>
                  <div className="w-full flex justify-center items-center my-2">
                    <span className=" text-cendiatra-gris-1 font-bold text-start text-lg">
                      Cendiatra no asume la responsabilidad de errores en la
                      información proporcionada por el cliente.
                    </span>
                  </div>
                </ContenedorTituloResaltado>
              </div>
            </div>
          </>
        ) : (
          <div className="w-full flex flex-wrap justify-end items-center my-5">
            {/* <div className="w-3/12 flex justify-center ">
              <span className=" text-cendiatra-verde-2 font-bold text-start text-2xl">
                Valor a recibir
              </span>
            </div>
            <div className="w-3/12 flex justify-center">
              <span className="text-cendiatra-verde-2 font-bold text-center text-2xl">
                {aplicarFormatoMoneda(totalTabla)}
              </span>
            </div> */}
            {/* CODIGO COMENTADO POR CAMBIO EN RETENCIONES */}
            <div className="w-full flex justify-center items-center my-5">
              <span className=" text-cendiatra-gris-1 font-bold text-start text-lg">
                Cendiatra no asume la responsabilidad de errores en la
                información proporcionada por el cliente.
              </span>
            </div>
          </div>
        )}

        <div className="w-full flex justify-center items-center">
          <AreaDeTexto
            estilosContenedor={`w-6/12`}
            estilosAreaDeTexto={` rounded relative block w-full  p-1.5 border border-cendiatra text-cendiatra-gris-3 rounded-lg focus:outline-none  sm:text-sm`}
            titulo={'Detalle de la recarga'}
            placeholder={'DESCRIPCIÓN (TEXTO LARGO)'}
            cambioValor={(e) => manejarCambioDetalle(e.target.value)}
            valor={contextoRecargarSaldo.formularioRecargarSaldo.detalle}
            rows={8}
          />
        </div>
        <div className="w-full flex justify-center items-center mt-10">
          <BotonSimple
            texto={'Continuar'}
            estilosBoton={clsx(
              'h-40px w-40 p-1.5 rounded-lg bg-cover bg-no-repeat bg-center text-white font-bold text-14px',
              {
                'bg-cendiatra':
                  valoresTabla.montoRecarga &&
                  Object.keys(errors).length === 0 &&
                  !alertaICA &&
                  aplicaRetenciones,
                'bg-cendiatra-gris-2 pointer-events-none': !(
                  valoresTabla.montoRecarga &&
                  Object.keys(errors).length === 0 &&
                  !alertaICA &&
                  aplicaRetenciones
                ),
              }
            )}
            funcion={() => manejarGuardar(valoresTabla, municipio, totalTabla)}
            deshabilitado={
              (!valoresTabla.montoRecarga ||
                Object.keys(errors).length !== 0 ||
                alertaICA) &&
              !aplicaRetenciones
            }
          />
        </div>
      </div>
    </>
  )
}

export default FormularioRecargarCuentaServicios
